import { Observable } from 'rxjs';

export class ActionButtonConfig {
  public iconUrl?: string; // iconUrl in case of an external svg (no ion icon available)
  public badge$?: Observable<number>; // red badge that goes on top of the icon
  public isDisabledFn?: () => boolean;
  public hideFn?: () => boolean;
  public class?: string;
  public dataTestId?: string;

  constructor(public tooltip: string, public icon: string, public handler: (event?) => void) {}

  get isDisabled() {
    return this.isDisabledFn ? this.isDisabledFn() : false;
  }

  get hide() {
    return this.hideFn ? this.hideFn() : false;
  }
}
